var particle_blendNormalPS = `
		if (a < 0.01) discard;
`;

export { particle_blendNormalPS as default };
